import { useQuery } from '@apollo/client'
import { ULTIMOS_MODIFICADOS_QUERY } from '../data/ultimo-modificados-query'
import { UltimosModificadosQueryGqlQuery } from '@/core/types/graphql'

export const useArquivosRecentes = () => {
  const { data: dataArquivosRecentes, loading: loadingArquivosRecentes } =
    useQuery<UltimosModificadosQueryGqlQuery>(ULTIMOS_MODIFICADOS_QUERY)

  return {
    dataArquivosRecentes,
    loadingArquivosRecentes
  }
}
